import { Box, Button, Typography, useTheme } from "@mui/material"
import { toHomePage } from "../actions/navigation"
import { useTranslation } from "react-i18next";
import { getAssetImagesUrl } from "../api/ApiDataHelper";

export default function NotFound() {

  const { t } = useTranslation();

  const theme = useTheme();

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '90vh'
      }}
    >
      <Box
        sx={{
          mb: "80px",
          display: "flex",
          fontSize: "18vw",
          width: "40vw",
          justifyContent: "center",
          alignItems: "center",
          span: {
            display: "flex",
            flex: "1 0 auto",
            width: "33%",
            fontWeight: "bold",
            alignItems: "center",
            justifyContent: "center",
          },
          img: {
            maxWidth: "100%",
            ratioBox: "1",
          },
          [theme.breakpoints.down('md')]: {
            width: "80%",
            fontSize: "30vw",
          }
        }}
      >
        <span>4</span>
        <span><img src={getAssetImagesUrl("logo.svg")} alt="styled giano logo svg" /></span>
        <span>4</span>
      </Box>
      <Typography
        component="div"
        variant="h3"
      >
        {t("label_pageNotFound")}
      </Typography>
      <Button
        variant='contained'
        disableElevation
        onClick={toHomePage}
        sx={{ marginTop: 4 }}
      >
        {t("label_go_home")}
      </Button>
    </Box>

  )
}
